interface RecommendTooltipViewProps {
  isOptionType: boolean;
}
export function RecommendTooltipView({ isOptionType }: RecommendTooltipViewProps) {
  return (
    <div>
      {isOptionType
        ? '사이즈 별 많이 구매한 신체정보를 기준으로 제공하는 내용으로 참고용으로만 활용해 주세요.'
        : '이 상품을 구매한 유저들의 신체정보를 기준으로 제공하는 내용입니다. 해당 사이즈는 참고용이므로 정확한 사이즈는 실측 정보를 확인해 주세요.'}
    </div>
  );
}
